module.exports = __webpack_public_path__ + "img/Dantam Hair 49.b63641cf.jpg";